export default {
	message: 'Please click the Synchronize button to add new accounts from SM to our system!',
	selector: 'Select a Stock',
	button: 'Synchronize'
};
